export default [
  {
    name: '20年期',
    value: '20'
  },
  {
    name: '30年期',
    value: '30'
  },
  {
    name: '至60周岁',
    value: '60'
  },
  {
    name: '至65周岁',
    value: '65'
  },
  {
    name: '至70周岁',
    value: '70'
  }
]



// WEBPACK FOOTER //
// ./src/data/insurancePeriods.js